import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PlanGuard } from '@/components/guards';
import { GoalRouteView } from '@/pages/workspaces/goals/[goalId]/routing';
import { validateGoalSearch } from '@/pages/workspaces/goals/[goalId]/search';
import { BUILDER_PLAN_SLUG } from '@/services/auth/plan-slugs';
import { LastWorkspaceResolver } from './-components';
import { ShowGoalsGate } from './-goals-route';

/** A goal's page frame, around its overview or milestone tab. */
function GoalRoute() {
  const { goalId } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <ShowGoalsGate>
        <PlanGuard excludedPlans={[BUILDER_PLAN_SLUG]}>
          <GoalRouteView goalId={goalId}>
            <Outlet />
          </GoalRouteView>
        </PlanGuard>
      </ShowGoalsGate>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/goals/$goalId')({
  component: GoalRoute,
  validateSearch: validateGoalSearch,
});
